<template>
  <div>
    <h3>このサイトについて</h3>
    <p>
      公共のスポーツ施設の休日の空き情報を分かりやすく発信しています。
      <br />空きが出たらtwitterでつぶやいています。
    </p>
  </div>
</template>

<script>
export default {
  name: "About",
  mounted: function() {
    document.title = `サイト情報`;
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", `このサイトについて説明しています`);
  }
};
</script>